import { UpdateDirectSupervisionProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';

export enum ACTIONS {
	setState = 'setState',
	setSupervisedSessionId = 'setSupervisedSessionId',
	setPromtedEffectively = 'setPromtedEffectively',
	setReinforcerImplementation = 'setReinforcerImplementation',
	setDataEnteredCorrectly = 'setDataEnteredCorrectly',
	setFeedbackResponses = 'setFeedbackResponses',
	setImplementationOfGoals = 'setImplementationOfGoals',
	setResponseToBehavioralFeedback = 'setResponseToBehavioralFeedback',
	setClientPerformance = 'setClientPerformance',
	setChangesAndMeasurementsObserved = 'setChangesAndMeasurementsObserved',
	setDescriptionOfSession = 'setDescriptionOfSession',
	setSignature = 'setSignature',
	setLocationId = 'setLocationId',
	setClientTelehealthLocationId = 'setClientTelehealthLocationId',
	setUserTelehealthLocationId = 'setUserTelehealthLocationId',
	setParticipants = 'setParticipants',
	setFeedbackOther = 'setFeedbackOther',
	setDirectSupervisionParticipantOther = 'setDirectSupervisionParticipantOther',
}

export interface ActionProperties {
	payload: any;

	type: keyof typeof ACTIONS;
}

export const initialDirectSupervisionState: UpdateDirectSupervisionProperties = {
	behaviorTechName: '',
	changesAndMeasurementsObserved: '',
	clientPerformance: '',
	dataEnteredCorrectly: false,
	date: '',
	descriptionOfSession: '',
	endTime: '',
	feedbackResponses: [],
	implementationOfGoal: '',
	isReinforcerImplementationRight: false,
	locationId: '',
	promptedEffectively: false,
	responseToBehavioralFeedback: '',
	sessionId: '',
	signature: '',
	startTime: '',
	submit: false,
	supervisedSessionId: null,
	supervisorId: '',
	forcedOperation: false,
	clientTelehealthLocationId: '',
	userTelehealthLocationId: '',
	participantResponses: [],
	clientId: '',
	reportId: '',
	sessionSummary: '',
	feedbackOther: '',
	directSupervisionParticipantOther: '',
};

export const directSuperVisionReducer = (
	state: UpdateDirectSupervisionProperties,
	action: ActionProperties,
): UpdateDirectSupervisionProperties => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setSupervisedSessionId:
			return {
				...state,
				supervisedSessionId: payload,
			};
		case ACTIONS.setPromtedEffectively:
			return {
				...state,
				promptedEffectively: payload,
			};
		case ACTIONS.setReinforcerImplementation:
			return {
				...state,
				isReinforcerImplementationRight: payload,
			};
		case ACTIONS.setDataEnteredCorrectly:
			return {
				...state,
				dataEnteredCorrectly: payload,
			};
		case ACTIONS.setFeedbackResponses:
			return {
				...state,
				feedbackResponses: payload,
			};
		case ACTIONS.setParticipants:
			return {
				...state,
				participantResponses: payload,
			};
		case ACTIONS.setImplementationOfGoals:
			return {
				...state,
				implementationOfGoal: payload,
			};
		case ACTIONS.setResponseToBehavioralFeedback:
			return {
				...state,
				responseToBehavioralFeedback: payload,
			};
		case ACTIONS.setClientPerformance:
			return {
				...state,
				clientPerformance: payload,
			};
		case ACTIONS.setChangesAndMeasurementsObserved:
			return {
				...state,
				changesAndMeasurementsObserved: payload,
			};
		case ACTIONS.setDescriptionOfSession:
			return {
				...state,
				descriptionOfSession: payload,
			};
		case ACTIONS.setSignature:
			return {
				...state,
				signature: payload,
			};
		case ACTIONS.setLocationId:
			return {
				...state,
				locationId: payload,
			};
		case ACTIONS.setClientTelehealthLocationId:
			return {
				...state,
				clientTelehealthLocationId: payload,
			};
		case ACTIONS.setUserTelehealthLocationId:
			return {
				...state,
				userTelehealthLocationId: payload,
			};
		case ACTIONS.setFeedbackOther:
			return {
				...state,
				feedbackOther: payload,
			};
		case ACTIONS.setDirectSupervisionParticipantOther:
			return {
				...state,
				directSupervisionParticipantOther: payload,
			};
		default:
			return state;
	}
};

export enum ERRORS {
	SupervisedSessionId = 'SupervisedSessionId',
	PromtedEffectively = 'PromtedEffectively',
	ReinforcerImplementation = 'ReinforcerImplementation',
	DataEnteredCorrectly = 'DataEnteredCorrectly',
	FeedbackResponses = 'FeedbackResponses',
	ImplementationOfGoal = 'ImplementationOfGoal',
	ResponseToBehavioralFeedback = 'ResponseToBehavioralFeedback',
	ClientPerformance = 'ClientPerformance',
	ChangesAndMeasurementsObserved = 'ChangesAndMeasurementsObserved',
	DescriptionOfSession = 'DescriptionOfSession',
	Signature = 'Signature',
	LocationId = 'LocationId',
	ParticipantResponses = 'ParticipantResponses',
	FeedbackOther = 'FeedbackOther',
	DirectSupervisionParticipantOther = 'DirectSupervisionParticipantOther',
}

interface DirectSupervisionErrorStateProperties {
	ChangesAndMeasurementsObserved: boolean;
	ClientPerformance: boolean;
	DataEnteredCorrectly: boolean;
	DescriptionOfSession: boolean;
	DirectSupervisionParticipantOther: boolean;
	FeedbackOther: boolean;
	FeedbackResponses: boolean;
	ImplementationOfGoal: boolean;
	LocationId: boolean;
	ParticipantResponses: boolean;
	PromtedEffectively: boolean;
	ReinforcerImplementation: boolean;
	ResponseToBehavioralFeedback: boolean;
	Signature: boolean;

	SupervisedSessionId: boolean;
}

interface ErrorActionProperties {
	payload: any;

	type: keyof typeof ERRORS;
}

export const initialDirectSupervisionErrorState: DirectSupervisionErrorStateProperties = {
	SupervisedSessionId: false,
	PromtedEffectively: false,
	ReinforcerImplementation: false,
	DataEnteredCorrectly: false,
	FeedbackResponses: false,
	ImplementationOfGoal: false,
	ResponseToBehavioralFeedback: false,
	ClientPerformance: false,
	ChangesAndMeasurementsObserved: false,
	DescriptionOfSession: false,
	Signature: false,
	LocationId: false,
	ParticipantResponses: false,
	FeedbackOther: false,
	DirectSupervisionParticipantOther: false,
};

export const directSuperVisionErrorReducer = (
	state: DirectSupervisionErrorStateProperties,
	action: ErrorActionProperties,
) => {
	const { payload, type } = action;

	switch (type) {
		case ERRORS[type]:
			return {
				...state,
				[type]: payload,
			};
		default:
			return state;
	}
};
